import { autoinject } from 'aurelia-framework';
import { AssessmentContext } from 'app/core/lib/assessment-context';
import { State } from 'app/shared/lib/state';
import * as Core from 'app/core/models/essette-api';


@autoinject
export class QuestionBase {

    ////****************** Fields and Properties ************************************////
    public question!: Core.AssessmentQuestion;
    protected showHistory: boolean = false;
    protected readonly: boolean = false;
    public required: boolean = false;
    public isValid: boolean = false;
    protected state: State = new State();
    public labelId: string | null = null;


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(protected readonly context: AssessmentContext) { }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    protected getAnswerHistory(multiple: boolean = false): Core.AssessmentAnswer[] {
        let answers: Core.AssessmentAnswer[] = [];
        if(this.context && this.context.attachment && this.context.attachment.history && this.context.attachment.history.answers) {
            answers = this.context.attachment.history.answers.filter(a => {
                if(!a.sharedQuestion) {
                    return (a.question!.id === this.question.id);
                } else if(this.question.sharedQuestion) {
                    return (a.sharedQuestion.id === this.question.sharedQuestion.id);
                }
                return false;
            });
        }

        // If the question can have multiple answers, we need to reduce all question answers for a single session into a single answer
        // object by joining all answer text values with a comma
        if(multiple) {
            answers = answers.reduce<Core.AssessmentAnswer[]>((ans: Core.AssessmentAnswer[], x: Core.AssessmentAnswer) => {
                const a = ans.find(a => {
                    if(a.attachment && a.attachment.session && x.attachment && x.attachment.session) {
                        return a.attachment.session.id === x.attachment.session.id
                    }
                    return false;
                });
                if(a) {
                    a.value += `, ${x.value}`;
                }
                else {
                    ans.push(x);
                }

                return ans;
            }, []);
        }

        return answers;
    }


    ////****************** Service Calls ********************************************////

}
